import { ChangeEvent } from 'react';

import { FeaturedPacks } from './FeaturedPacks/FeaturedPacks';
import { LabelInput, NewRow, SpeechBubble } from '../shared';
import { LanguageType } from '@lifeserver/shared';

import { languages } from '../utils/utils';
import { getTranslationLoadingText } from './utils';

import { CreateCarousel } from '../types/carouselTypes';
import { PackListItem } from '../types/packTypes';

import styles from './Overview.module.scss';

type OverviewProps = {
    language: LanguageType;
    carousel: CreateCarousel;
    translationCategoryId?: string;
    translations?: Record<LanguageType, string>;
    isTranslationsPending: boolean;
    translationsError: Error | null;
    onInputChange: (
        e: ChangeEvent<HTMLInputElement>,
        language?: LanguageType,
    ) => void;
    onClickLoadTranslations: () => void;
    onItemsChange: (packItems: PackListItem[]) => void;
};

function Overview(props: OverviewProps) {
    const {
        language,
        carousel,
        translationCategoryId,
        translations,
        isTranslationsPending,
        translationsError,
        onInputChange,
        onClickLoadTranslations,
    } = props;

    const translationsLoadingText = getTranslationLoadingText(
        translationCategoryId,
        translations,
        isTranslationsPending,
        translationsError,
    );

    return (
        <>
            <LabelInput
                object={carousel}
                size="wide"
                name="carouselName"
                label="Category ID"
                onChange={(e) => onInputChange(e)}
            />
            <LabelInput
                object={carousel}
                size="wide"
                name="displayName"
                tooltip="Localized name"
                language={language}
                label="display name in "
                labelHighlight={languages[language]}
                onChange={(e) => onInputChange(e, language)}
            />
            <NewRow />
            <div className={styles.importBlock}>
                <div className={styles.translationsImportWrapper}>
                    <button
                        disabled={translationCategoryId !== undefined}
                        onClick={() => onClickLoadTranslations()}
                    >
                        Load translations from Google Sheet
                    </button>

                    {translationsLoadingText && (
                        <SpeechBubble
                            style={{
                                justifyContent: 'left',
                                marginLeft: 20,
                            }}
                        >
                            {translationsLoadingText}
                        </SpeechBubble>
                    )}
                </div>
                {carousel.featured && (
                    <FeaturedPacks onLoad={props.onItemsChange} />
                )}
            </div>
        </>
    );
}

export default Overview;
